import { render } from "./Channel.vue?vue&type=template&id=3110e710&ts=true"
import script from "./Channel.vue?vue&type=script&lang=ts"
export * from "./Channel.vue?vue&type=script&lang=ts"

import exportComponent from "/home/cipherx/.thelounge-app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"client/components/Channel.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3110e710"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3110e710', __exports__)) {
    api.reload('3110e710', __exports__)
  }
  
  module.hot.accept("./Channel.vue?vue&type=template&id=3110e710&ts=true", () => {
    api.rerender('3110e710', render)
  })

}


export default __exports__